import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { CircularProgress, TextField, TextFieldProps, useTheme } from "@mui/material"
import { grey } from "@mui/material/colors"
import { FC, ReactNode, useState } from "react"
import Center from "./Center"
import { IHasChildren } from "./types/IHasChildren"
import { faCaretUp } from "@fortawesome/pro-duotone-svg-icons"

type SelectProps = Omit<TextFieldProps,"select"> & IHasChildren & { loading?: boolean, icon?: ReactNode }

const Select: FC<SelectProps> = ({
    children,
    loading,
    icon,
    ...rest
}) => {

    const theme = useTheme();

    const [open, setOpen] = useState<boolean>(false);

    return (
        <TextField
            {...rest}
            select
            sx={{
                '& label': {
                    color: grey[700]
                },
                '& p': {
                    color: grey[700]
                },
                '& .MuiOutlinedInput-root': {
                    paddingRight: '0px',
                    '& fieldset': {
                        borderColor: 'rgba(0, 0, 0, 0.2)',
                    },
                    '&:hover fieldset': {
                        borderColor: rest.disabled ?
                                'rgba(0, 0, 0, 0.2)' :
                                'rgb(0, 0, 0)',
                    },
                    '&.Mui-focused fieldset': {
                        borderColor: theme.palette.primary.main
                    },
                },
                ...rest.sx
            }}
            SelectProps={{
                sx: { "& .MuiSelect-icon": { top: 10 } },
                onOpen: () => setOpen(true),
                onClose: () => setOpen(false),
                IconComponent: () => undefined,
                ...rest.SelectProps,
            }}
            InputProps={{
                endAdornment: icon ? (
                    <Center width='0px'>
                        {
                            loading && 
                            <CircularProgress sx={{ position: 'absolute', right: '12px', color: grey[500], maxWidth: '16px', maxHeight: '16px' }} />
                        }
                        <FontAwesomeIcon 
                            style={{
                                position: 'absolute',
                                right: '15px',
                                rotate: open ? '0deg' : '180deg'
                            }}
                            color={grey[600]} 
                            icon={faCaretUp} 
                        />
                    </Center>
                ) : undefined,
                ...rest.InputProps
            }}
            InputLabelProps={{
                shrink: true,
                ...rest.InputLabelProps
            }}
        >
            {children}
        </TextField>
    )
}

export default Select